module.exports = __webpack_public_path__ + "static/media/bd-doctor-nurse.dcb27295.jpg";